import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, StatCard } from "@/components/common";
import { FileText, Layers, ClipboardCheck, ShieldAlert, IndianRupee } from "lucide-react";
import { PacksTab } from "./testseries/PacksTab";
import { ExamsTab } from "./testseries/ExamsTab";
import { ReviewsTab } from "./testseries/ReviewsTab";

export default function AdminTestSeries() {
  const [tab, setTab] = useState("packs");
  const [s, setS] = useState(null);
  const [exams, setExams] = useState([]);
  const loadStats = useCallback(() => api.get("/testseries/admin/stats").then(({ data }) => setS(data)), []);
  const loadExams = useCallback(() => api.get("/testseries/admin/exams").then(({ data }) => setExams(data)), []);
  useEffect(() => { loadStats(); loadExams(); }, [loadStats, loadExams]);
  const t = (k, l) => <button onClick={() => setTab(k)} className={`px-4 py-2 text-sm font-semibold border-b-2 whitespace-nowrap ${tab === k ? "border-crimson text-navy" : "border-transparent text-muted-foreground"}`} data-testid={`ats-tab-${k}`}>{l}</button>;
  return (
    <div data-testid="admin-test-series">
      <PageHeader title="Test Series" subtitle="Exams, test packs, questions, proctoring evidence and written-answer reviews" />
      {s && <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
        <StatCard label="Test packs" value={s.packs} icon={Layers} testid="ats-stat-packs" />
        <StatCard label="Tests / Questions" value={`${s.tests} / ${s.questions}`} icon={FileText} testid="ats-stat-tests" />
        <StatCard label="Pending reviews" value={s.pending_review} icon={ClipboardCheck} accent="bg-crimson" testid="ats-stat-pending" />
        <StatCard label="Violation auto-submits" value={s.violations} icon={ShieldAlert} testid="ats-stat-violations" />
        <StatCard label="Pack revenue" value={`₹${s.revenue}`} icon={IndianRupee} testid="ats-stat-revenue" />
      </div>}
      <div className="flex gap-2 border-b border-border mb-5 overflow-x-auto">{t("packs", "Test Packs")}{t("reviews", `Attempts & Reviews${s?.pending_review ? ` (${s.pending_review})` : ""}`)}{t("exams", "Exams & Subjects")}</div>
      {tab === "packs" && <PacksTab exams={exams} onChange={loadStats} />}
      {tab === "reviews" && <ReviewsTab onChange={loadStats} />}
      {tab === "exams" && <ExamsTab exams={exams} reload={loadExams} />}
    </div>
  );
}
